import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\User\DisableUserTwoFactorController::__invoke
* @see app/Http/Controllers/User/DisableUserTwoFactorController.php:16
* @route '/users/{user}/two-factor'
*/
export const disable = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disable.url(args, options),
    method: 'delete',
})

disable.definition = {
    methods: ["delete"],
    url: '/users/{user}/two-factor',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\User\DisableUserTwoFactorController::__invoke
* @see app/Http/Controllers/User/DisableUserTwoFactorController.php:16
* @route '/users/{user}/two-factor'
*/
disable.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return disable.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\DisableUserTwoFactorController::__invoke
* @see app/Http/Controllers/User/DisableUserTwoFactorController.php:16
* @route '/users/{user}/two-factor'
*/
disable.delete = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disable.url(args, options),
    method: 'delete',
})

const twoFactor = {
    disable: Object.assign(disable, disable),
}

export default twoFactor